import * as React from "react";

import { AuthConsumer } from "../../Providers/AuthProvider";

export const SignInRedirect = () => (
    <AuthConsumer>
        {({ signinRedirect }) => {
            signinRedirect();
            return <span></span>;
        }}
    </AuthConsumer>
);